import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { ShieldCheck, Lock } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiErrorDetail } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/admin");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-[calc(100vh-8rem)] flex items-center justify-center px-4 py-16">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src="/anni-logo-square.png" alt="Anni's Place" className="w-16 h-16 object-contain mx-auto mb-4" />
          <h1 className="font-heading text-3xl font-black tracking-tight">Beheer Login</h1>
          <p className="text-[#525252] mt-2 text-sm">Log in om toernooiresultaten in te voeren en te beheren.</p>
        </div>

        <form onSubmit={submit} className="bg-white border border-[#E5E5E5] p-8 space-y-6" data-testid="login-form">
          <div>
            <label className="text-xs uppercase tracking-[0.15em] font-semibold text-[#525252]">E-mail</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="login-email"
              required
              className="w-full border-b-2 border-[#E5E5E5] bg-transparent py-3 px-1 text-[#0A0A0A] focus:outline-none focus:border-[#D4AF37] transition-colors"
              placeholder="admin@apdarts.nl"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-[0.15em] font-semibold text-[#525252]">Wachtwoord</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="login-password"
              required
              className="w-full border-b-2 border-[#E5E5E5] bg-transparent py-3 px-1 text-[#0A0A0A] focus:outline-none focus:border-[#D4AF37] transition-colors"
              placeholder="••••••••"
            />
          </div>

          {error && (
            <div data-testid="login-error" className="text-sm text-[#DC2626] bg-[#DC2626]/5 border border-[#DC2626]/20 px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit"
            className="w-full flex items-center justify-center gap-2 bg-[#0A0A0A] text-[#D4AF37] py-3.5 font-semibold hover:bg-[#1A1A1A] transition-colors disabled:opacity-60"
          >
            <Lock className="w-4 h-4" /> {loading ? "Bezig met inloggen…" : "Inloggen"}
          </button>
        </form>
        <p className="text-center text-xs text-[#A0A0A0] mt-6">
          <Link to="/" className="hover:text-[#0A0A0A]">← Terug naar home</Link>
        </p>
      </div>
    </div>
  );
}
